import { assign } from 'lodash';
import { DATA_STATES } from '@/store/consts';
import { STATE_KEYS } from './state';

const MUTATION_TYPES = {
  SET_WORKATO_TOKEN: 'setWorkatoToken',
  SET_WORKATO_TOKEN_REFRESH_FLAG: 'setWorkatoTokenRefreshFlag',
  SET_WORKATO_CONFIG_VALUES: 'setWorkatoConfigValues',
  SET_WORKATO_RECIPE: 'setWorkatoRecipe',
  SET_WORKATO_ADMINS: 'setWorkatoAdmins',
  SET_EXISTING_WORKATO_ACCOUNT: 'setExistingWorkatoAccount',
  SET_EXISTING_WORKATO_USER: 'setExistingWorkatoUser',
  SET_NEW_WORKATO_USER: 'setNewWorkatoUser',
  SET_NEW_WORKATO_ACCOUNT: 'setNewWorkatoAccount',
  SET_DATA_STATE: 'setDataState',
  SET_PRE_BUILD_MODAL_FLAG: 'setPreBuildModalFlag',
};

const mutations = {
  [MUTATION_TYPES.SET_WORKATO_TOKEN](state, items) {
    state[STATE_KEYS.WORKATO_TOKEN] = items || {};
  },
  [MUTATION_TYPES.SET_WORKATO_TOKEN_REFRESH_FLAG](state, flag) {
    state[STATE_KEYS.WORKATO_TOKEN_NEED_TO_REFRESH] = flag;
  },
  [MUTATION_TYPES.SET_WORKATO_CONFIG_VALUES](state, values) {
    state[STATE_KEYS.WORKATO_CONFIG_VALUES] = assign({}, state[STATE_KEYS.WORKATO_CONFIG_VALUES], values);
  },
  [MUTATION_TYPES.SET_WORKATO_RECIPE](state, items) {
    state[STATE_KEYS.WORKATO_RECIPE] = items || {};
  },
  [MUTATION_TYPES.SET_WORKATO_RECIPE_LOAD_STATE](state, dataState) {
    state[STATE_KEYS.WORKATO_RECIPE_LOAD_STATE] = dataState;
  },
  [MUTATION_TYPES.SET_WORKATO_ADMINS](state, items) {
    state[STATE_KEYS.WORKATO_ADMINS] = items || {};
  },
  [MUTATION_TYPES.SET_EXISTING_WORKATO_ACCOUNT](state, items) {
    state[STATE_KEYS.EXISTING_WORKATO_ACCOUNT] = items || {};
  },
  [MUTATION_TYPES.SET_EXISTING_WORKATO_USER](state, items) {
    state[STATE_KEYS.EXISTING_WORKATO_USER] = items || {};
  },
  [MUTATION_TYPES.SET_NEW_WORKATO_USER](state, items) {
    state[STATE_KEYS.NEW_WORKATO_USER] = items || {};
  },
  [MUTATION_TYPES.SET_NEW_WORKATO_ACCOUNT](state, items) {
    state[STATE_KEYS.NEW_WORKATO_ACCOUNT] = items || {};
  },
  [MUTATION_TYPES.SET_DATA_STATE](state, dataState) {
    switch (dataState) {
      case DATA_STATES.SUCCESS: {
        state[STATE_KEYS.ERROR_COUNT] = 0;
        state[STATE_KEYS.LAST_UPDATE_TIME] = Date.now();
        break;
      }
      case DATA_STATES.ERROR: {
        state[STATE_KEYS.ERROR_COUNT] += 1;
        break;
      }
      case DATA_STATES.NONE: {
        state[STATE_KEYS.ERROR_COUNT] = 0;
        state[STATE_KEYS.LAST_UPDATE_TIME] = null;
        break;
      }
      default:
        break;
    }
    state[STATE_KEYS.DATA_STATE] = dataState;
  },
  [MUTATION_TYPES.SET_PRE_BUILD_MODAL_FLAG](state, obj) {
    state[STATE_KEYS.DO_NOT_SHOW_PRE_BUILD_RECIPES_MODAL] = obj;
  },
};

export {
  mutations,
  MUTATION_TYPES,
};
